import React, { useState, useEffect } from 'react';
import { FaInfoCircle } from 'react-icons/fa';
import { Clause } from '../../../../static/types/clauseTypes/clauseType';
import '../../../../css/infoBulle.css';
import useAppContext from '../../../../hooks/useAppContext';
import { AppContextType } from '../../../../context/AppContext';

type ClauseProps = {
  clause: Clause,
  changeClause: (data: Partial<Clause>) => void,
  defaultValue?: string
}

const ComponentsClause: React.FC<ClauseProps> = ({
  clause,
  changeClause,
  defaultValue = "La cession d'actions à un tiers à quelque titre que ce soit est soumise à l'agrément préalable des associés, statuant à la majorité des associés disposant du droit de vote."
}) => {

  
  const {
      draftFormData, setDraftFormData
  } = useAppContext() as AppContextType
  
  const stringifyDraft = ( data: any ) => { return JSON.stringify( data )}
  const parseDraft: any = () => { return draftFormData ? JSON.parse( draftFormData ) : {} }

  const [value, setValue] = useState(clause.clause || defaultValue);
  const [showTooltip, setShowTooltip] = useState(false);

  useEffect(() => {
    // Appliquer la valeur par défaut si clause.clause est vide
    if (!clause.clause?.trim()) {
      setValue(defaultValue);
      changeClause({ clause: defaultValue }); // Mettre à jour le parent avec la valeur par défaut

      let draft = parseDraft()
      const tempDraft = { ...draft, clause: defaultValue }
      setDraftFormData( stringifyDraft( tempDraft ))
    }
  }, [clause.clause, defaultValue, changeClause]);

  const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    const newValue = event.target.value;
    setValue(newValue);
    changeClause({ clause: newValue || defaultValue }); // Utiliser la valeur par défaut si newValue est vide

    
    let draft = parseDraft()
    const tempDraft = { ...draft, clause: newValue || defaultValue }
    setDraftFormData( stringifyDraft( tempDraft ))
  };

  return (
    <div className="tab-content p-4 shadow">
      <p className="text-center">
        <strong>
          La cession d'actions à un tiers à quelque titre que ce soit est
          soumise à l'agrément préalable des associés, statuant à la majorité
          des associés disposant du droit de vote.
        </strong>
      </p>
      <div className="mb-3 row">
        <label htmlFor="Clause" className="col-sm-2 col-form-label">
          <div>
            Clause
          </div>
          <div className="info-icon-wrapper">
            {/* Ondes */}
            <span className="echo-wave echo-wave-left echo-wave-1" />
            <span className="echo-wave echo-wave-right echo-wave-1" />
            <span className="echo-wave echo-wave-left echo-wave-2" />
            <span className="echo-wave echo-wave-right echo-wave-2" />

            <FaInfoCircle
              className="icon-zoom-orange"
              onMouseEnter={() => setShowTooltip(true)}
              onMouseLeave={() => setShowTooltip(false)}
              onClick={() => setShowTooltip(!showTooltip)}
              aria-label="Information sur la clause"
            />
            {showTooltip && (
              <div className="info-tooltip">
                <strong>IMPORTANT : </strong>
                Dans la majorité des cas, le texte ci-dessous est celui utilisé. Toutefois, vérifiez vos statuts et, si besoin, remplacez ce texte par celui de vos statuts.
              </div>
            )}
          </div>
        </label>
        <div className="col-sm-10">
          <textarea
            className="form-control"
            id="clause"
            value={value}
            onChange={handleChange}
            rows={4}
          />
        </div>
      </div>
    </div>
  );
};

export default ComponentsClause;